<form class="filters-form mb-4">
  <label class="form-control mb-0 flex-1">
    <div class="position-relative">
      <input
        type="search"
        name="main_pages_search"
        class="pr-5"
        [formControl]="searchControl"
        [placeholder]="'SEARCH' | translate"
        spellcheck="false"
      />

      <button
        type="button"
        class="postfix icon-button"
        [attr.aria-label]="'SEARCH' | translate"
      >
        <div [inlineSVG]="'assets/img/icons/search-icon-4.svg'"></div>
      </button>
    </div>
  </label>

  <div class="ml-auto">
    <div class="position-relative" dropdown>
      <button
        id="button-filter"
        dropdownToggle
        type="button"
        class="filter-button dropdown-toggle dropdown-filter"
        aria-controls="dropdown-basic"
        [tooltip]="'BATCH_MAILING.BATCHES_TAB.FILTER' | translate"
      >
        <span
          class="filter-button-icon"
          [inlineSVG]="'assets/img/icons/filter.svg'"
        ></span>
        <span>{{ 'BATCH_MAILING.BATCHES_TAB.FILTER' | translate }}</span>
      </button>
      <ul
        id="dropdown-filter"
        *dropdownMenu
        class="dropdown-menu"
        role="menu"
        aria-labelledby="button-filter"
      >
        <li role="menuitem">
          <button
            type="button"
            (click)="typeFilter(BatchStatusEnum.UNCOMMITED)"
            class="dropdown-item"
            [class.active]="
              (queryParams$ | async).status === BatchStatusEnum.UNCOMMITED
            "
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.STATUS_UNCOMMITTED' | translate }}
          </button>
        </li>
        <li role="menuitem">
          <button
            type="button"
            (click)="typeFilter(BatchStatusEnum.COMMITED)"
            class="dropdown-item"
            [class.active]="
              (queryParams$ | async).status === BatchStatusEnum.COMMITED
            "
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.STATUS_COMMITTED' | translate }}
          </button>
        </li>
        <li role="menuitem">
          <button
            type="button"
            (click)="typeFilter(BatchStatusEnum.IN_OPS)"
            class="dropdown-item"
            [class.active]="
              (queryParams$ | async).status === BatchStatusEnum.IN_OPS
            "
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.STATUS_IN_OPS' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </div>

  <div>
    <div class="position-relative" dropdown [isDisabled]="!data?.length">
      <button
        id="button-duplicate"
        dropdownToggle
        class="filter-button"
        type="button"
        [tooltip]="'BATCH_MAILING.BATCHES_TAB.DUPLICATE' | translate"
      >
        <span
          class="filter-button-icon"
          [inlineSVG]="'assets/img/icons/duplicate.svg'"
        ></span>
        <span>{{ 'BATCH_MAILING.BATCHES_TAB.DUPLICATE' | translate }}</span>
      </button>
      <ul
        id="dropdown-duplicate"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-left"
        role="menu"
        aria-labelledby="button-duplicate"
      >
        <li role="menuitem">
          <button
            type="button"
            (click)="duplicate('duplicate-full')"
            class="dropdown-item"
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.DUPLICATE_FULL' | translate }}
          </button>
        </li>
        <li role="menuitem">
          <button
            type="button"
            (click)="duplicate('duplicate')"
            class="dropdown-item"
          >
            {{ 'BATCH_MAILING.BATCHES_TAB.DUPLICATE_PARTIAL' | translate }}
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div>
    <button
      class="filter-button red"
      type="button"
      [disabled]="!data?.length || !selected?.length"
      [tooltip]="deleteTooltipTemplate"
      (click)="remove()"
    >
      <fa-icon class="filter-button-icon red" [icon]="faTrashAlt"></fa-icon>
      <span class="red">{{ 'DELETE' | translate }}</span>
    </button>
    <ng-template #deleteTooltipTemplate>
      @if (!selected.length) {
        {{ 'BATCH_MAILING.BATCHES_TAB.ACTIONS.DELETING_PICK_ONE' | translate }}
      }
      @if (selected.length) {
        {{ 'DELETE' | translate }}
      }
    </ng-template>
  </div>
</form>
